<script async setup lang="ts">
import t from '@/i18n/translations'
import { CULTURE, packageName } from '@/composables/helpers'
import type { IPackageDto } from '@/composables/Interfaces/appInterfaces'
import { computed } from 'vue'

const props = defineProps<{
  item: IPackageDto | undefined
}>()

let nights = ''

if (props.item?.periods?.length) {
  const nightsArray = props.item.periods.map((period) => period.nights)
  const nMin = Math.min(...nightsArray)
  const nMax = Math.max(...nightsArray)

  nights = nMin === nMax ? `${nMin}` : `${nMin}-${nMax}`
}

const formattedStartDate = computed(() => {
  if (!props.item?.earliestStart) return ''
  return new Date(props.item.earliestStart).toLocaleDateString(CULTURE, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  })
})

const formattedEndDate = computed(() => {
  if (!props.item?.latestEnd) return ''
  return new Date(props.item.latestEnd).toLocaleDateString(CULTURE, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  })
})

const imageUrl = props.item?.images[0].format.toString().replace('{0}', 'b') //b is PicSize.Big
</script>

<template>
  <div class="relative w-full hover:text-inherit hover:no-underline md:basis-[48%]">
    <div class="ui-company-card pui-accocart-card flex h-full min-h-32 flex-row overflow-hidden !rounded shadow-md md:border md:shadow-none">
      <div class="relative w-2/5">
        <div class="h-full overflow-hidden">
          <img class="aspect-video h-full w-full object-cover" :alt="props.item?.images[0].title" :src="imageUrl" />
        </div>
      </div>
      <div class="flex w-3/5 flex-col p-4">
        <span class="mb-2 text-[1.08rem] font-bold">{{ packageName(props.item, CULTURE) }}</span>
        <div class="flex gap-1">
          <span class="font-semibold">{{ t(`${CULTURE}.enquiry.selectedPackage.nights`) + ':' }}</span>
          <span>{{ nights }}</span>
        </div>
        <div class="flex gap-2">
          <div class="flex flex-col lg:flex-row lg:gap-1">
            <span class="font-semibold">{{ t(`${CULTURE}.enquiry.selectedPackage.period`) + ':' }}</span>
            <span>{{ formattedStartDate }} - {{ formattedEndDate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
